import React, { memo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import CustomThemeProvider from './CustomThemeProvider';
import Layout from './Layout';

const LayoutWithTheme = memo((props) => {
  const themeType = useSelector(
    state => state.form.document?.appConfig?.theme?.type,
    shallowEqual
  );
  return (
    <CustomThemeProvider themeType={themeType}>
      <Layout {...props} />
    </CustomThemeProvider>
  );
});

export default LayoutWithTheme